import { useState, type FormEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Mark } from '../components/Brand';
import { Button, Field, Input } from '../components/ui';
import { login } from '../services/endpoints/auth';
import './LoginPage.css';

export function LoginPage() {
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!email || !password) return;
    setBusy(true); setError(null);
    try {
      await login(email.trim(), password);
      const to = (loc.state as { from?: { pathname: string } })?.from?.pathname || '/';
      nav(to, { replace: true });
    } catch (err) {
      setError((err as Error).message || 'Sign-in failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="nb-login">
      <div className="nb-login__paper">
        <header className="nb-login__head">
          <Mark size={56} />
          <div>
            <div className="nb-login__eyebrow">EDITOR'S DESK · ADMIN</div>
            <h1 className="nb-login__title">Ifa <em>App</em></h1>
          </div>
        </header>
        <form className="nb-login__form" onSubmit={submit}>
          <Field label="Email">
            <Input
              type="email"
              autoComplete="username"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </Field>
          <Field label="Password">
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </Field>
          {error && <div className="nb-login__err">{error}</div>}
          <Button type="submit" tone="ember" disabled={busy} style={{ width: '100%', justifyContent: 'center', padding: '14px' }}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
        <footer className="nb-login__foot">
          <span>v1.0 · {new Date().getFullYear()}</span>
          <span>IFA Company · Lagos</span>
        </footer>
      </div>
    </div>
  );
}
